import React from 'react';
import { CheckCircle2, XCircle } from 'lucide-react';
interface ComparisonRow {
  brand: string;
  form: string;
  dose: string;
  tested: boolean;
  guarantee: string;
  gentle: boolean;
  rating: string;
}
interface ComparisonTableProps {
  data: ComparisonRow[];
}
export function ComparisonTable({
  data
}: ComparisonTableProps) {
  return <div className="overflow-x-auto -mx-4 px-4 sm:mx-0 sm:px-0" data-id="element-1">
      <table className="w-full border-collapse bg-white shadow-md rounded-lg overflow-hidden min-w-[700px]" data-id="element-2">
        <thead data-id="element-3">
          <tr className="bg-blue-600 text-white" data-id="element-4">
            <th className="px-4 sm:px-6 py-4 sm:py-5 text-left font-bold text-base sm:text-lg" data-id="element-5">
              Brand
            </th>
            <th className="px-4 sm:px-6 py-4 sm:py-5 text-left font-bold text-base sm:text-lg" data-id="element-6">
              Form
            </th>
            <th className="px-4 sm:px-6 py-4 sm:py-5 text-left font-bold text-base sm:text-lg" data-id="element-7">
              Dose
            </th>
            <th className="px-4 sm:px-6 py-4 sm:py-5 text-center font-bold text-base sm:text-lg" data-id="element-8">
              Tested
            </th>
            <th className="px-4 sm:px-6 py-4 sm:py-5 text-left font-bold text-base sm:text-lg" data-id="element-9">
              Guarantee
            </th>
            <th className="px-4 sm:px-6 py-4 sm:py-5 text-center font-bold text-base sm:text-lg" data-id="element-10">
              Gentle
            </th>
            <th className="px-4 sm:px-6 py-4 sm:py-5 text-left font-bold text-base sm:text-lg" data-id="element-11">
              Rating
            </th>
          </tr>
        </thead>
        <tbody data-id="element-12">
          {data.map((row, index) => <tr key={index} className={`${index % 2 === 0 ? 'bg-gray-50' : 'bg-white'} border-b-2 border-gray-200`} data-id="element-13">
              <td className="px-4 sm:px-6 py-4 sm:py-5 font-semibold text-base sm:text-lg text-gray-900" data-id="element-14">
                {row.brand}
              </td>
              <td className="px-4 sm:px-6 py-4 sm:py-5 text-base sm:text-lg text-gray-800" data-id="element-15">
                {row.form}
              </td>
              <td className="px-4 sm:px-6 py-4 sm:py-5 text-base sm:text-lg text-gray-800" data-id="element-16">
                {row.dose}
              </td>
              <td className="px-4 sm:px-6 py-4 sm:py-5 text-center" data-id="element-17">
                {row.tested ? <CheckCircle2 className="inline w-7 h-7 sm:w-8 sm:h-8 text-green-600" data-id="element-18" /> : <XCircle className="inline w-7 h-7 sm:w-8 sm:h-8 text-red-600" data-id="element-19" />}
              </td>
              <td className="px-4 sm:px-6 py-4 sm:py-5 text-base sm:text-lg text-gray-800" data-id="element-20">
                {row.guarantee}
              </td>
              <td className="px-4 sm:px-6 py-4 sm:py-5 text-center" data-id="element-21">
                {row.gentle ? <CheckCircle2 className="inline w-7 h-7 sm:w-8 sm:h-8 text-green-600" data-id="element-22" /> : <XCircle className="inline w-7 h-7 sm:w-8 sm:h-8 text-red-600" data-id="element-23" />}
              </td>
              <td className="px-4 sm:px-6 py-4 sm:py-5 font-bold text-base sm:text-lg text-gray-900" data-id="element-24">
                {row.rating}
              </td>
            </tr>)}
        </tbody>
      </table>
    </div>;
}